// extracted by mini-css-extract-plugin
export default {"triggerButton":"triggerButton__wcNk-4KdDH_HThvkvHLBq"};